document.addEventListener('click',event=>{const link=event.target.closest('.sg-mobile-nav a');if(link)link.closest('details').open=false;});
document.addEventListener('click',event=>{if(event.target.closest('[data-sg-guide]')){event.preventDefault();document.querySelector('#sg-guide')?.showModal();}if(event.target.closest('[data-sg-close]'))document.querySelector('#sg-guide')?.close();});
document.addEventListener('shopify:section:load',()=>{document.querySelectorAll('.sg-mobile-nav').forEach(menu=>{menu.open=false;});});
document.addEventListener('cart:updated',event=>{const count=event.detail?.cart?.item_count;if(typeof count==='number')document.querySelectorAll('[data-sg-cart-count]').forEach(el=>el.textContent=count);});

(()=>{
  const setMenu=(root,open)=>{
    const button=root.querySelector('[data-sg-menu-toggle]');
    const panel=root.querySelector(':scope > nav');
    if(!button||!panel)return;
    button.setAttribute('aria-expanded',String(open));
    panel.hidden=!open;
  };
  const openMenu=root=>{
    document.querySelectorAll('.sg-range-menu').forEach(other=>setMenu(other,other===root));
  };
  const init=()=>{
    document.querySelectorAll('.sg-range-menu').forEach(root=>{
      if(root.dataset.sgMenuReady)return;
      root.dataset.sgMenuReady='true';
      setMenu(root,false);
      let closeTimer;
      root.addEventListener('pointerenter',()=>{
        if(!window.matchMedia('(hover: hover)').matches)return;
        clearTimeout(closeTimer);
        openMenu(root);
      });
      root.addEventListener('pointerleave',()=>{
        if(!window.matchMedia('(hover: hover)').matches)return;
        closeTimer=setTimeout(()=>{if(!root.contains(document.activeElement))setMenu(root,false);},140);
      });
      root.addEventListener('focusout',event=>{
        if(!root.contains(event.relatedTarget))setMenu(root,false);
      });
    });
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-sg-menu-toggle]');
    if(button){
      const root=button.closest('.sg-range-menu');
      if(button.getAttribute('aria-expanded')==='true')setMenu(root,false);
      else openMenu(root);
      return;
    }
    document.querySelectorAll('.sg-range-menu').forEach(root=>{
      if(!root.contains(event.target))setMenu(root,false);
    });
  });
  document.addEventListener('keydown',event=>{
    const root=event.target.closest('.sg-range-menu');
    if(!root)return;
    const button=root.querySelector('[data-sg-menu-toggle]');
    if(event.key==='Escape'){
      event.preventDefault();
      setMenu(root,false);
      button.focus();
    }else if(event.key==='ArrowDown'&&event.target===button){
      event.preventDefault();
      openMenu(root);
      root.querySelector(':scope > nav a')?.focus();
    }
  });
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();



(() => {
  const readColours = () => new Set((new URLSearchParams(location.search).get('sg_colour') || '').split(',').filter(c => c && c !== 'all'));
  let colours = readColours();
  let sort = new URLSearchParams(location.search).get('sort_by') || 'manual';
  let pending = false;
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; apply(); }); } };
  const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
  const apply = () => {
    const root = document.querySelector('[data-sg-grass-collection]');
    const grid = root?.querySelector('.collection__products');
    if (!grid || !root.querySelector('[data-sg-colour-input]')) return;
    const valid = new Set([...root.querySelectorAll('[data-sg-colour-input]')].map(el => el.value));
    colours = new Set([...colours].filter(c => valid.has(c)));
    let cards = [...grid.querySelectorAll(':scope > .product-item')];
    if (sort === 'manual') {
      const ordered = [...cards].sort((a,b) => (Number(a.dataset.sgPileHeight) || 999) - (Number(b.dataset.sgPileHeight) || 999) || (a.dataset.title || '').localeCompare(b.dataset.title || ''));
      if (cards.some((c,i) => c !== ordered[i])) { const fragment = document.createDocumentFragment(); ordered.forEach(c => fragment.append(c)); grid.append(fragment); cards = ordered; }
    }
    const counts = {}; let visible = 0;
    cards.forEach(card => { const key = card.dataset.sgColour || 'green'; counts[key] = (counts[key] || 0) + 1; const hide = colours.size > 0 && !colours.has(key); if (card.hidden !== hide) card.hidden = hide; if (!hide) visible++; });
    root.querySelectorAll('[data-sg-colour-input]').forEach(input => {
      input.checked = colours.has(input.value);
      input.disabled = !counts[input.value] && !input.checked;
      const label = input.closest('[data-sg-colour-label]');
      label?.setAttribute('data-filter-item-content-disabled', String(input.disabled));
      setText(label?.querySelector('[data-sg-colour-option-count]'), '(' + (counts[input.value] || 0) + ')');
    });
    root.querySelectorAll('[data-sg-colour-filter]').forEach(group => {
      group.setAttribute('data-filter-group-has-active-filters', String(colours.size > 0));
      const names = [...group.querySelectorAll('[data-sg-colour-input]:checked')].map(input => input.closest('label').querySelector('[data-sg-colour-name]').textContent);
      setText(group.querySelector('[data-sg-colour-active]'), names.join(', '));
      group.querySelectorAll('[data-sg-colour-reset]').forEach(button => button.setAttribute('data-has-active-filters', String(colours.size > 0)));
    });
    const text = (root.dataset.sgCountLabel || '__COUNT__ products').replace('__COUNT__', visible);
    root.querySelectorAll('[data-results-count]').forEach(el => setText(el, text));
    const empty = root.querySelector('[data-sg-colour-empty]'); if (empty) empty.hidden = visible > 0;
    const url = new URL(location.href);
    if (colours.size) url.searchParams.set('sg_colour', [...colours].sort().join(',')); else url.searchParams.delete('sg_colour');
    if (url.href !== location.href) history.replaceState(history.state, '', url.href);
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sg-colour-input]')) { if (event.target.checked) colours.add(event.target.value); else colours.delete(event.target.value); apply(); }
    else if (event.target.matches('[data-sort-item-input]') && event.target.closest('[data-sg-grass-collection]')) { sort = event.target.value; schedule(); }
  });
  document.addEventListener('click', event => { if (!event.target.closest('[data-sg-grass-collection]')) return; if (event.target.closest('[data-sg-colour-reset]')) { event.preventDefault(); colours.clear(); apply(); } else if (event.target.closest('[data-clear-all-filters]')) { colours.clear(); schedule(); } });
  addEventListener('popstate', () => { colours = readColours(); sort = new URLSearchParams(location.search).get('sort_by') || 'manual'; schedule(); });
  const init = () => {
    const root = document.querySelector('[data-sg-grass-collection]');
    if (root && !root.dataset.sgColourReady) { root.dataset.sgColourReady = 'true'; new MutationObserver(schedule).observe(root, {childList:true,subtree:true}); }
    apply();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

document.addEventListener('click', event => {
  document.querySelectorAll('.sg-mobile-nav[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || event.defaultPrevented) return;
  const menu = event.target.closest('.sg-mobile-nav[open]');
  if (menu) { menu.open = false; menu.querySelector(':scope > summary')?.focus(); }
});
